import { ProductMin } from '@/services/m-commerce-api/product/product'

export interface HomePageContent {
  homeBanners: HomeBanner[]
  specialOffers: SpecialOffer[]
  onlineshopBanners: OnlineShopBanner[]
  helps: Help[]
  sdgs: SDG[]
  apps: AppCta[]
  footer: FooterData
  footerBanners: FooterBanner[]
  shopItems: Record<string, ProductMin[]>
}
export interface HomeBanner {
  id: number
  titleMn: string
  titleEn: string
  subtitleMn: string
  subtitleEn: string
  image: string
}

export interface SpecialOffer {
  id: number
  documentId: string
  titleMn: string
  titleEn: string
  descriptionMn: string
  descriptionEn: string
  headerImage: string
  coverImage: string
  type: OfferType
  link?: string
  expireDate?: Date
  publishedAt: Date
  publishedDate: Date
  content?: SpecialOfferContent[]
  footerMn?: string
  footerEn?: string
}

export interface SpecialOfferContent {
  id: number
  __component: string
  titleMn?: string
  titleEn?: string
  bodyMn?: string
  bodyEn?: string
  bodyTextMn?: string
  bodyTextEn?: string
  image?: string
  descriptionEn?: string
  descriptionMn?: string
  isFreeSize?: boolean
}

export enum OfferType {
  Урамшуулал = 'Promotion',
  Мэдээ = 'News',
  Зөвлөмж = 'Tip',
  SDG = 'SDG',
  Мэдэгдэл = 'Notice',
  Бүртгэл = 'Registration'
}

export interface Help {
  id: number
  titleMn: string
  titleEn: string
  descriptionMn: string
  descriptionEn: string
  icon: string
  link?: string
}
export interface SDG {
  id: number
  titleMn: string
  titleEn: string
  descriptionMn: string
  descriptionEn: string
  image: string
  link?: string
}
export interface AppCta {
  id: number
  nameMn: string
  nameEn: string
  descriptionMn: string
  descriptionEn: string
  appstoreUrl: string
  playstoreUrl: string
  icon: string
  qr: string
}

export interface FooterBanner {
  id: number
  titleMn: string
  titleEn: string
  buttonTextMn: string
  buttonTextEn: string
  link: string
  image: string
}

export interface FooterData {
  about_us: Link[]
  help: Link[]
  contact_us: KeyValPair[]
  social_links: SocialLink[]
}
export interface Link {
  id: number
  nameMn: string
  nameEn: string
  link?: string
}
export interface KeyValPair {
  id: number
  keyMn: string
  keyEn: string
  valueMn: string
  valueEn: string
}
export interface SocialLink {
  id: any
  nameMn: string
  nameEn: string
  link: string
  image: { url: string }
}

export interface OnlineShopBanner {
  id: number
  titleMn: string
  titleEn: string
  subtitleMn: string
  subtitleEn: string
  image: string
}
